import Table from "./components/table";

import React, { useState, useEffect } from "react";

export function DefaultColumnFilter({
  column: { filterValue, preFilteredRows, setFilter },
}) {
  const count = preFilteredRows.length;

  return (
    <input
      value={filterValue || ""}
      onChange={(e) => {
        setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
      }}
      placeholder={`Search ${count} records...`}
    />
  );
}

function App() {
  const columns = [
    {
      Header: "CATEGORY",
      accessor: "category",
      Filter: DefaultColumnFilter,
      filter: "fuzzyText",
    },
    {
      Header: "TITLE",
      accessor: "title",
      Filter: DefaultColumnFilter,
      filter: "fuzzyText",
    },
    {
      Header: "KEYWORDS",
      accessor: "keywords",
      Filter: DefaultColumnFilter,
      filter: "fuzzyText",
    },
  ];

  const [content, setContent] = useState([]);
  const [status, setStatus] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/vnd.gathercontent.v2json");
    myHeaders.append(
      "Authorization",
      `Basic d2lydGhAaW1wYWN0LXNvbHV0aW9ucy5jaDoyYjUzNTJjZC1mYjk5LTQ0NDItODY3Yi02OTg5MGUzMmY2MmM=`
    );

    async function fetchContent() {
      const response = await fetch(
        "https://api.gathercontent.com/items?project_id=296964",
        {
          method: "GET",
          headers: myHeaders,
        }
      );

      const body = await response.json();
      setStatus(body.data);
      const holder = [];
      const enqueueQueries = async () => {
        const promises = [];
        const myHeaders = new Headers();
        myHeaders.append(
          "Content-Type",
          "application/vnd.gathercontent.v2json"
        );
        myHeaders.append(
          "Authorization",
          `Basic d2lydGhAaW1wYWN0LXNvbHV0aW9ucy5jaDoyYjUzNTJjZC1mYjk5LTQ0NDItODY3Yi02OTg5MGUzMmY2MmM=`
        );

        for (let i = 0; i < body.data.length; i++) {
          promises.push(
            fetch(`https://api.gathercontent.com/items/${body.data[i].id}`, {
              method: "GET",
              headers: myHeaders,
            })
              .then((result) => {
                return result.json();
              })
              .then((result) => {
                holder.push(result.data.config[0]);
              })
          );
        }
        return Promise.all(promises);
      };

      await enqueueQueries();
      return Promise.resolve(holder);
    }

    async function prepContent(data) {
      const holder = [];
      let temp;
      for (let i = 0; i < data.length; i++) {
        temp = { category: "", title: "", keywords: "" };
        for (let j = 0; j < data[i].elements.length; j++) {
          switch (j) {
            case 0:
              temp.category = data[i].elements[j].value;
              break;
            case 1:
              temp.title = data[i].elements[j].value;
              break;
            case 2:
              break;
            case 3:
              temp.keywords = data[i].elements[j].value;
              break;
            default:
              break;
          }
        }
        holder.push(temp);
      }

      return Promise.resolve(holder);
    }

    if (isLoading) {
      fetchContent().then((response) => {
        prepContent(response).then((formattedData) => {
          setContent(formattedData);
          setIsLoading(false);
        });
      });
    }
  }, [content, isLoading]);

  return (
    <div className="flex items-center justify-center min-w-full min-h-full">
      {isLoading ? <div></div> : <Table columns={columns} content={content} />}
    </div>
  );
}

export default App;
